<template>
    <div 
        id="ariane"
        v-bind:okanMain="okanMain"
    >    

    <div 
        id="home"
         @click="switchLevel(0)"
         v-if="false"
    ></div>

    <div 
        v-for="(button, buttonIndex) in buttons"
        v-bind:key="buttonIndex"
        class="arianeItem"
        v-bind:class="[{'disabled' : buttonIndex > okanMain.arianeLevel}, {'selected' : buttonIndex == okanMain.arianeLevel}]"
        @click="switchLevel(buttonIndex)"
    >
        {{button}}
    </div>

    </div>

</template>

<script>



export default {
  name: 'Ariane',
  components: {

  },
  props: {
      okanMain : Object,
  },
  data() {
    return {
        buttons : [ "Bâtiment", "Appartement"],//"Quartier",
    }
  },
  methods: {
    switchLevel(buttonIndex){
        if(buttonIndex < this.okanMain.arianeLevel){
            this.okanMain.downGradeArianeLevel(buttonIndex)
        }
    }
    
  },
  mounted() {
      
  }
}
</script>

<style src="../assets/css/ariane.css"></style>